import { defineMessages } from 'react-intl';

export const chargesMessages = defineMessages({
    charges: {
        id: 'charges',
        defaultMessage: 'Charges',
    },
    charge: {
        id: 'charge',
        defaultMessage: 'Charge',
    },
    debit: {
        id: 'debit',
        defaultMessage: 'Debit',
    },
    credit: {
        id: 'credit',
        defaultMessage: 'Credit',
    },
    invoice: {
        id: 'invoice',
        defaultMessage: 'Invoice',
    },
    category: {
        id: 'category',
        defaultMessage: 'Category',
    },
    oneTime: {
        id: 'one-time',
        defaultMessage: 'One time',
    },
    chargeCategorySub: {
        id: 'charge-category-sub',
        defaultMessage: 'Subscription',
    },
    voucher: {
        id: 'voucher',
        defaultMessage: 'Voucher',
    },
    discount: {
        id: 'discount',
        defaultMessage: 'Discount',
    },
    status: {
        id: 'status',
        defaultMessage: 'Status',
    },
    pending: {
        id: 'pending',
        defaultMessage: 'Pending',
    },
    invoiced: {
        id: 'invoiced',
        defaultMessage: 'Invoiced',
    },
    voided: {
        id: 'voided',
        defaultMessage: 'Voided',
    },
    refunded: {
        id: 'refunded',
        defaultMessage: 'Refunded',
    },
    periodStart: {
        id: 'period-start',
        defaultMessage: 'Period start',
    },
    periodEnd: {
        id: 'period-end',
        defaultMessage: 'Period end',
    },
    item: {
        id: 'item',
        defaultMessage: 'Item',
    },
    externalProduct: {
        id: 'external-product',
        defaultMessage: 'External product',
    },
    externalSource: {
        id: 'external-source',
        defaultMessage: 'External source',
    },
});
